import { createRequestTypes } from '../utils';

export const SAVE_INCI_SUBSTANCE = createRequestTypes('inciSubstance/SAVE_INCI_SUBSTANCE');
